import React, { FC } from 'react';
import Create from 'components/document-templates/components/Create';

const Screen: FC = () => (
  <Create
    templatesEntityName="templates"
    templatesDropdownsEntityName="template-dropdowns"
    templatesDropdownsEntityEndpoint="templates/dropdown-options"
  />
);

export default Screen;
